import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import NotificationItem from './NotificationItem';

interface NotificationBoxProps {
  isInView: boolean;
}

/**
 * A component that displays a list of notification items in a styled box
 */
const NotificationBox = React.memo(({ isInView }: NotificationBoxProps) => {
  const notificationItems = useMemo(
    () => [
      {
        iconName: 'arrow',
        text: 'Know price rises first'
      },
      {
        iconName: 'plus',
        text: 'See injury news instantly'
      },
      {
        iconName: 'star',
        text: 'Get weekly top picks'
      }
    ],
    []
  );

  return (
    <motion.div
      className="pt-3 pb-2 px-4 w-full"
      initial={{ opacity: 0 }}
      animate={{ opacity: isInView ? 1 : 0 }}
      transition={{ delay: 0.4 }}
    >
      <div className="space-y-2 mb-1">
        {notificationItems.map((item, index) => (
          <NotificationItem
            key={index}
            iconName={item.iconName}
            text={item.text}
          />
        ))}
      </div>
    </motion.div>
  );
});

NotificationBox.displayName = 'NotificationBox';

export default NotificationBox;
